import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';

export default function useFormSyncToUrl(form) {
    const navigate = useNavigate();
    const location = useLocation();

    // 将表单数据追加到URL
    const setMemory = (extra = {}) => {
        if (form){
            const search = queryString.stringify({ ...form.getFieldsValue(), ...extra });
            navigate(`${location.pathname}?${search}`);
        }
    };

    // 从URL中获取数据追加到表单
    const loadMemory = () => {
        const values = queryString.parse(location.search);
        if (values && form) form.setFieldsValue(values);
        return values;
    };

    return { setMemory, loadMemory };
}
